import Swal from "sweetalert2";

export const product_promo_api_methods = {
  fetch_discount_types() {
    this.isLoading = true;
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_promo_code_types/`,
      method: "GET",
      headers: {
        Authorization: `Token ${this.get_token()}`,
        "Content-Type": "application/json",
      },
      success: (response) => {
        this.discount_types = (response.data || []).map((type) => ({
          id: type.id,
          value: type.id,
          label: type.name.charAt(0).toUpperCase() + type.name.slice(1),
          name: type.name,
        }));
        this.discount_type = this.discount_types?.[0]?.id ?? "";
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  },
  create_catalogue_product_promo_codes() {
    if (!this.validate_promo_code_form()) return;

    this.isLoading = true;
    $.ajax({
      type: "POST",
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/create_catalogue_promo_code/`,
      data: JSON.stringify(this.build_payload({
        product_id: undefined,
      })),
      processData: true,
      contentType: "application/json",
      headers: {
        Authorization: `Token ${this.get_token()}`,
      },
      success: (response) => {
        if (response.status === "success") {
          Swal.fire({
            icon: "success",
            title: "Catalogue Promo Created",
            text: response.message || "Promo code was created for all catalogue products.",
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            $("#product_promo_code_form_modal").modal("hide");
            this.reset_form();
            if (this.return_to_catalogue_promo_manager) {
              this.return_to_catalogue_promo_manager = false;
              $("#catalogue_promo_code_manager_modal").modal("show");
              this.get_catalogue_promo_codes();
            }
          });
        }
      },
      error: (response) => {
        this.show_error(response, "An error occurred while creating catalogue promo code, please try again.");
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  },
  create_product_promo_code() {
    if (!this.validate_promo_code_form()) return;

    $.ajax({
      type: "POST",
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/create_product_promo_code/`,
      data: JSON.stringify(this.build_payload()),
      processData: true,
      contentType: "application/json",
      headers: {
        Authorization: `Token ${this.get_token()}`,
      },
      success: (response) => {
        if (response.status === "success") {
          Swal.fire({
            icon: "success",
            title: "Promo Code Created",
            text: response.message,
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            $("#product_promo_code_form_modal").modal("hide");
            if (response.data) {
              this.product_promo_codes.unshift(response.data);
            }
            this.get_product_promo_codes();
            this.$emit("promo-updated", {
              product_id: this.selected_product_id,
              promo: response.data,
            });
            this.reset_form();
            if (this.return_to_promo_manager) {
              this.return_to_promo_manager = false;
              $("#product_promo_code_manager_modal").modal("show");
            }
          });
        }
      },
      error: (response) => {
        this.show_error(response, "An error occurred while creating promo code, please try again.");
      },
    });
  },
  update_product_promo_code(silent = false) {
    if (!this.validate_promo_code_form()) return;

    $.ajax({
      type: "POST",
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/update_promo_code/`,
      data: JSON.stringify(this.build_payload({
        product_promo_code_id: this.editing_product_promo_code_id,
        promo_code_discount_id: this.editing_product_promo_code_id,
      })),
      processData: true,
      contentType: "application/json",
      headers: {
        Authorization: `Token ${this.get_token()}`,
      },
      success: (response) => {
        if (response.status !== "success") return;

        const index = this.product_promo_codes.findIndex(
          (promo) => String(this.get_promo_code_discount_id(promo)) === String(this.editing_product_promo_code_id),
        );
        const catalogue_index = this.catalogue_promo_codes.findIndex(
          (promo) => String(this.get_promo_code_discount_id(promo)) === String(this.editing_product_promo_code_id),
        );

        if (index !== -1) this.product_promo_codes.splice(index, 1, response.data);
        if (catalogue_index !== -1) this.catalogue_promo_codes.splice(catalogue_index, 1, response.data);

        this.$emit("promo-updated", {
          product_id: this.selected_product_id,
          promo: response.data,
        });

        if (silent) {
          this.reset_form();
          return;
        }

        Swal.fire({
          icon: "success",
          title: "Promo Code Updated",
          text: response.message,
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          $("#product_promo_code_form_modal").modal("hide");
          this.reset_form();
          if (this.return_to_promo_manager) {
            this.return_to_promo_manager = false;
            $("#product_promo_code_manager_modal").modal("show");
          }
          if (this.return_to_catalogue_promo_manager) {
            this.return_to_catalogue_promo_manager = false;
            $("#catalogue_promo_code_manager_modal").modal("show");
          }
        });
      },
      error: (response) => {
        this.show_error(response, "An error occurred while updating promo code, please try again.");
      },
    });
  },
  get_product_promo_codes() {
    if (!this.selected_product_id) return;
    this.is_loading = true;
    $.ajax({
      type: "POST",
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_product_promo_codes/`,
      data: JSON.stringify({
        base_profile_id: this.get_selected_base_profile_id(),
        product_id: this.selected_product_id,
      }),
      processData: true,
      contentType: "application/json",
      headers: {
        Authorization: `Token ${this.get_token()}`,
      },
      success: (response) => {
        if (response.status === "success") {
          this.product_promo_codes = response.data || [];
        }
      },
      error: (response) => {
        this.show_error(response, "An error occurred while loading promo codes, please try again.");
      },
      complete: () => {
        this.is_loading = false;
      },
    });
  },
  toggle_product_promo_status(product_promo) {
    const previous_state = product_promo.is_active;
    this.editing_product_promo_code_id = this.get_promo_code_discount_id(product_promo);
    this.apply_product_promo_to_form(product_promo);
    this.is_catalogue_promo = !this.selected_product_id;
    this.is_active = !previous_state;
    this.update_product_promo_code(true);
  },
  delete_product_promo_code(product_promo) {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this promo code?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    }).then((result) => {
      if (!result.isConfirmed) return;

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/delete_promo_code/`,
        data: JSON.stringify({
          base_profile_id: this.get_selected_base_profile_id(),
          promo_code_discount_id: this.get_promo_code_discount_id(product_promo),
          product_promo_code_id: this.get_promo_code_discount_id(product_promo),
          ...(this.selected_product_id ? { product_id: Number(this.selected_product_id) } : {}),
        }),
        headers: {
          Authorization: `Token ${this.get_token()}`,
          "Content-Type": "application/json",
        },
        success: (response) => {
          if (response.status !== "success") return;

          Swal.fire({
            icon: "success",
            title: "Promo Code Deleted",
            text: response.message,
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            const removed_promo_id = String(this.get_promo_code_discount_id(product_promo));
            this.product_promo_codes = this.product_promo_codes.filter(
              (promo) => String(this.get_promo_code_discount_id(promo)) !== removed_promo_id,
            );
            this.catalogue_promo_codes = this.catalogue_promo_codes.filter(
              (promo) => String(this.get_promo_code_discount_id(promo)) !== removed_promo_id,
            );
            this.$emit("promo-deleted", {
              product_id: this.selected_product_id,
              promo_id: this.get_promo_code_discount_id(product_promo),
            });
          });
        },
        error: (response) => {
          this.show_error(response, "An error occurred while deleting promo code, please try again.");
        },
      });
    });
  },
  get_catalogue_promo_codes() {
    const base_profile_id = this.get_selected_base_profile_id();
    if (!base_profile_id) return;

    this.is_loading = true;
    $.ajax({
      type: "GET",
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/catalogue_promo_codes/`,
      data: {
        base_profile_id,
      },
      headers: {
        Authorization: `Token ${this.get_token()}`,
      },
      success: (response) => {
        if (response.status === "success") {
          this.catalogue_promo_codes = response.data || [];
        }
      },
      error: (response) => {
        this.show_error(response, "An error occurred while loading catalogue promo codes.");
      },
      complete: () => {
        this.is_loading = false;
      },
    });
  },
  show_error(response, fallback) {
    const response_data = response?.responseJSON || {};
    Swal.fire({
      icon: "error",
      title: "Error",
      text: response_data.message || fallback,
      showConfirmButton: false,
      timer: 3000,
    });
  },
};
